import React, { FC, useContext, useState } from "react";
import Paragraph from "./Paragraph";
import { userAPI } from "../Redux/services/UserService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../Infrastructure/provider/AuthProvider";
import { GlobalVariablesContext } from "../Infrastructure/provider/GlobalVariablesProvider";
import { ReactComponent as Logo } from "../Public/ASA.svg";

interface HeaderProps {
    name: string;
}

const Header: FC<HeaderProps> = ({ name }) => {
    const [logoutUser] = userAPI.useLogoutUserMutation();
    const navigate = useNavigate();
    const { setUser, user } = useContext<any>(AuthContext);
    const { headerTitle } = useContext(GlobalVariablesContext);
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const showBackButton = !location.pathname.startsWith("/category");

    const handleLogout = () => {
        logoutUser("");
        localStorage.removeItem("userToken");
        setUser(null);
    };

    const handleGoBack = () => navigate(-1);

    return (
        <header className="flex items-center justify-between gap-3 py-3 px-4 mb-6 mt-2 rounded-xl bg-[#f2f2f2] shadow-sm relative">
            {/* Левая часть */}
            <div className="flex items-center gap-4 min-w-[70px]">
                <Link to="/category">
                    <Logo className="w-[60px] md:w-[70px]" />
                </Link>
            </div>

            {/* Центральная часть */}
            <div className="flex-1 flex justify-center items-center">
                <Paragraph>
                    <div className="flex items-center">
                        {showBackButton && (
                            <button
                                onClick={handleGoBack}
                                className=" hover:opacity-80 transition"
                                title="Назад"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="#4573c4"
                                    width="28"
                                    height="28"
                                >
                                    <path d="M15.5 5L8 12l7.5 7V5z" />
                                </svg>
                            </button>
                        )}

                        <span
                            className="text-center text-lg sm:text-xl md:text-2xl font-semibold text-blue-900 max-w-[60vw] truncate"
                            title={headerTitle || name}
                        >
                            {headerTitle || name}
                        </span>
                    </div>
                </Paragraph>
            </div>

            {/* Правая часть */}
            <div className="flex items-center gap-2 min-w-[120px] justify-end">
                {/* Мобильное меню */}
                <button
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="md:hidden text-blue-700 hover:text-blue-500 transition"
                    aria-label="Меню"
                >
                    {menuOpen ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    )}
                </button>

                {/* Кнопки для десктопа */}
                <div className="hidden md:flex flex-wrap justify-end gap-2">
                    {user?.role === "admin" && (
                        <button
                            onClick={() => navigate("/admin")}
                            className="bg-[#4573c4] text-white px-4 py-1.5 rounded-md shadow-md text-sm hover:bg-[#365da3] transition"
                        >
                            Панель адмiнiстратора
                        </button>
                    )}
                    {(user?.role === "admin" || user?.role === "subadmin") && (
                        <button
                            onClick={() => navigate("/publicationsControl")}
                            className="bg-[#4573c4] text-white px-4 py-1.5 rounded-md shadow-md text-sm hover:bg-[#365da3] transition"
                        >
                            Публікації
                        </button>
                    )}
                    {user && (
                        <button
                            onClick={() => navigate('/personalAccount')}
                            className="bg-[#4573c4] text-white px-4 py-1.5 rounded-md shadow-md text-sm hover:bg-[#365da3] transition"
                        >
                            Особистий кабiнет
                        </button>
                    )}
                    {user && (
                        <button
                            onClick={handleLogout}
                            className="bg-[#4573c4] text-white px-4 py-1.5 rounded-md shadow-md text-sm hover:bg-[#365da3] transition"
                        >
                            Вийти
                        </button>
                    )}
                </div>


            </div>

            {/* Выпадающее меню для мобильных */}
            {menuOpen && (
                <div className="absolute top-full right-3 mt-2 flex flex-col gap-2 bg-white border border-gray-200 rounded-md shadow-md p-3 w-48 md:hidden z-50">
                    {user?.role === "admin" && (
                        <button
                            onClick={() => {
                                navigate("/admin");
                                setMenuOpen(false);
                            }}
                            className="bg-[#4573c4] text-white px-3 py-1.5 rounded-md hover:bg-[#365da3] transition text-sm"
                        >
                            Панель адмiнiстратора
                        </button>
                    )}
                    {(user?.role === "admin" || user?.role === "subadmin") && (
                        <button
                            onClick={() => {
                                navigate("/publicationsControl");
                                setMenuOpen(false);
                            }}
                            className="bg-[#4573c4] text-white px-3 py-1.5 rounded-md hover:bg-[#365da3] transition text-sm"
                        >
                            Публікації
                        </button>
                    )}

                    {user && (
                        <button
                            onClick={() => {
                                navigate('/personalAccount');
                                setMenuOpen(false);
                            }}
                            className="bg-[#4573c4] text-white px-3 py-1.5 rounded-md hover:bg-[#365da3] transition text-sm"
                        >
                           Особистий кабiнет
                        </button>
                    )}
                    {user && (
                        <button
                            onClick={() => {
                                handleLogout();
                                setMenuOpen(false);
                            }}
                            className="bg-[#4573c4] text-white px-3 py-1.5 rounded-md hover:bg-[#365da3] transition text-sm"
                        >
                            Вийти
                        </button>
                    )}


                </div>
            )}
        </header>
    );
};

export default Header;
